import React from 'react';
import styled, { css } from 'styled-components';
import { nanoid } from 'nanoid';
import { Tooltip, TrevorComponent } from '@trevor/ui-components';
import DashboardFilterRef from '@/util/DashboardFilterRef';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LayerWhere from '@/components/layers/LayerWhere';
import { buildClause } from '@/util/helpers/layer-helpers';

export const _WidgetFilter: TrevorComponent<{
  widgetFilter: DashboardFilterRef;
  appliedFilters: LayerWhere[];
  isApplied: boolean;
}> = ({ widgetFilter, appliedFilters, isApplied, className }) => {
  const tooltipId = nanoid();

  const layer = appliedFilters.find(
    (af) => af.lhs().name() === widgetFilter.name(),
  ) as LayerWhere;

  const clause = layer ? buildClause(layer) : null;

  return (
    <>
      <div className={className} data-tooltip-id={tooltipId}>
        <span>
          <FontAwesomeIcon icon="filter" />
        </span>
        <span>{widgetFilter.name()}</span>
      </div>
      <Tooltip id={tooltipId} place="bottom">
        {isApplied ? clause : 'No filter applied'}
      </Tooltip>
    </>
  );
};

export const WidgetFilter = styled(_WidgetFilter)`
  display: flex;
  border-radius: 4px;
  margin-right: 8px;
  margin-bottom: 3px;
  border: 1px solid #ddd;
  background: #f5f5f5;
  cursor: auto;
  color: #000;
  font-size: 0.9em;

  span:first-of-type {
    border-right: 1px solid #ddd;
    padding: 3px 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;

    svg {
      color: #37352f;
      font-size: 0.85em;
    }
  }

  span:last-of-type {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 3px 6px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  ${(p) =>
    p.isApplied &&
    css`
      background-color: #aad7f9;
      border-color: #aad7f9 !important;

      span {
        border-color: white !important;
      }
    `}
`;
